import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { sharpPosition, flatPosition, getAccidental } from "../../../../../common/parameters";
import handleTouch from "../../../../../common/helpers/handleTouch";
import getDoPosition from "../../../../../common/helpers/getDoPosition";
import { IMelodyTableData, IScore } from "../../../../../common/types";
import getDo from "../../../../../common/helpers/getDo";

import player from "../../../../player";
import piano from "../../../../piano";
import Icon from "../../../../icon";

import { parseDo } from "../../../Score/methods/changeDo";

import Wrapper from "../../Wrapper";

import getBirdsPath from "../Common/getBirdsPath";
import MessageDisplay from "../Common/MessageDisplay";
import NotEdited from "../Common/NotEdited";
import getScore from "../Common/getScore";
import getTempo from "../Common/getTempo";
import { SubmitButton, PlayBtn, CheckPlayBtn, Label } from "../common-style";

import ClefViolin from "./clef-violin";
import ClefBass from "./clef-bass";
import MelodyTableBar from "./MelodyTableBar";

import {
    ScrollWrap,
    Scroll,
    Wrap,
    StaffLines,
    StaffLine,
    System,
    Clef,
    Accidental,
    Accidentals,
    StyledSharpButton,
    StyledFlatButton,
    StyledNaturalButton,
    Asset1Wrapper,
    Asset2Wrapper,
    Asset3Wrapper,
    OctaveMark,
    DoClef,
    ClefLedger,
    ClefLedgerHolder,
} from "./styles";
import messages from "./messages";
import { loadPiano, getBarlinesWidth, getFullToneset, parseScore, scrollTo, isHintable, setStateAsync } from "./utils";
import { IBundle, IProps, IState } from "./interfaces";
import { IMelodyTableNote, ISolutionNote } from "./MelodyTableBar/interfaces";
import { getAccidentals } from "../../../Score/score-display/utils";

const Clock = require("waaclock");

const clefWidth: { [prop: string]: number } = {
    treble: 60,
    bass: 95,
    "treble-octave": 60,
    doClef: 43 * 1.1,
};

const clefCorrection = {
    treble: 0,
    bass: 4,
};

const clefTop = {
    treble: -4,
    bass: -2,
};

class MelodyTable extends Component<IProps, IState> {
    static defaultProps = {
        handlePlayCount: () => {},
        handleFailCount: () => {},
    };
    unmounting = false;
    loaded = false;
    clock: any = undefined;
    scroll: HTMLDivElement | null = null;
    wrap: HTMLDivElement | null = null;
    playScrollAnimation: ReturnType<typeof window.requestAnimationFrame> = 0;
    constructor(props: IProps) {
        super(props);
        this.state = {
            submitable: false,
            submited: false,
            playing: false,
            completed: false,
            checkPlaying: false,
            barlines: [],
            selectedModifier: null,
            playingProps: {},
            bars: false,
            scale: [],
            fullToneset: [],
            width: 0,
            hasFlat: false,
            hasSharp: false,
            doPos: { value: -6, alt: 0 },
            solutions: [],
            incorrects: [],
        };
        if (props.setReset) {
            props.setReset(this.resetTask);
        }
        if (props.saveState) {
            props.saveState(this.saveState);
        }
        if (props.restoreState) {
            props.restoreState(this.restoreState);
        }
        if (props.showSolution) {
            props.showSolution(this.showSolution);
        }
    }
    resetTask = () => {
        this.setUp();
        this.setState({
            submitable: false,
            submited: false,
            completed: false,
        });
    };
    saveState = () => {
        return {
            submited: this.state.submited,
            solutions: this.state.solutions,
            incorrects: this.state.incorrects,
            submitable: this.state.submitable,
            completed: this.state.completed,
        } as Partial<IState>;
    };
    restoreState = (state: Partial<IState>) => {
        this.setState({
            submited: state.submited!,
            solutions: state.solutions!,
            incorrects: state.incorrects!,
            submitable: state.submitable!,
            completed: state.completed!,
        });
    };
    showSolution = () => {
        const { solutions, bars, incorrects } = this.state;
        (bars as IMelodyTableNote[][]).forEach((bar, barIndex) => {
            bar.forEach((note, noteIndex) => {
                solutions[barIndex][noteIndex] = {
                    p: note.p!,
                    a: note.a,
                };
            });
        });
        this.setState({
            solutions,
            completed: true,
            submited: true,
            incorrects: incorrects.map(() => []),
        });
    };
    componentDidMount() {
        this.setUp();
    }

    componentWillUnmount() {
        this.unmounting = true;
        window.removeEventListener("blur", this.blur);
        if (this.state.playing || this.state.checkPlaying) {
            this.play();
        }
        setTimeout(() => {
            this.loaded = true;
        }, 500);
    }
    UNSAFE_componentWillReceiveProps = () => {
        if (!this.props.playPlan && !this.props.join && this.loaded) {
            setTimeout(() => {
                if (this.unmounting) return;
                this.setUp();
            });
        }
    };

    setUp() {
        let bundle: IBundle | null = null;
        let doPos = { value: -6, alt: 0 };
        const { task, plan } = this.props;
        const score = getScore(plan, task);
        if (score && score.bars[1] && score.bars[1].notes && score.bars[1].notes.length > 0) {
            if (score.doPos) {
                doPos = parseDo(score.doPos);
            }
            const accidentals = getAccidentals(score);
            bundle = parseScore(score, accidentals) as IBundle;
            if (!bundle) {
                return this.setState({ bars: false });
            }
        } else {
            return;
        }
        const { scale, bars, width, solutions, barlines, hasSharp, hasFlat } = bundle!;
        const incorrects = JSON.parse(JSON.stringify(solutions)) as number[][];
        let fullToneset = getFullToneset(scale);
        // TODO minden hang
        if (!this.props.preview) loadPiano(scale, hasSharp, hasFlat);
        if (this.props.preview) {
            bars.forEach((bar, barIndex) => {
                if (!bar) return;
                bar.forEach((note, noteIndex) => {
                    solutions[barIndex][noteIndex] = {
                        p: note.p!,
                        a: note.a,
                    };
                });
            });
        }

        this.setState({
            bars,
            scale,
            barlines,
            fullToneset,
            width,
            solutions,
            incorrects,
            doPos,
            completed: false,
            submited: false,
            submitable: false,
            hasSharp,
            hasFlat,
        });
    }

    selectTone = ({ barIndex, noteIndex, tone }: { barIndex: number, noteIndex: number, tone: number}) => {
        let { solutions, incorrects, selectedModifier, bars } = this.state;
        let solution: ISolutionNote = {
            p: tone,
            a: selectedModifier === "sharp" ? 1 : selectedModifier === "flat" ? -1 : 0,
        };
        const previousSameToneInBar = solutions[barIndex].slice(0, noteIndex).reverse().find(t => t !== null && t.p === tone);
        if (previousSameToneInBar && selectedModifier === null) {
            solution.a = previousSameToneInBar.a;
        }
        
        if (solutions[barIndex][noteIndex] && solutions[barIndex][noteIndex]!.p === tone) {
            solutions[barIndex][noteIndex] = {};
            solution = {};
        } else {
            solutions[barIndex][noteIndex] = solution;
            selectedModifier = null;
        }
        if ((bars as IMelodyTableNote[][])[barIndex][noteIndex].tie) {
            noteIndex++;
            if (!(bars as IMelodyTableNote[][])[barIndex][noteIndex]) {
                noteIndex = 0;
                barIndex++;
            }
            solutions[barIndex][noteIndex] = solution;
        }
        incorrects.forEach(bar => {
            bar.length = 0;
        });
        this.setState(
            { solutions: JSON.parse(JSON.stringify(solutions)), submited: false, incorrects, selectedModifier },
            this.checkReady
        );
        this.scrollIfNecessary({ barIndex, noteIndex });
    };

    scrollIfNecessary = ({ barIndex, noteIndex }: { barIndex: number, noteIndex: number }) => {
        const { doPos, barlines, playing, checkPlaying } = this.state;
        const bars = this.state.bars as IMelodyTableNote[][];
        if (playing || checkPlaying) return;
        const { task, isLow, plan } = this.props;
        const { data } = task;
        let bar = barIndex;
        let note = noteIndex;
        do {
            if (bars[bar][note + 1]) {
                note++;
            } else {
                bar++;
                note = 0;
            }
        } while (bars[bar]?.[note] && bars[bar][note].p === null);
        if (!bars[bar]?.[note]) return;

        let size: IMelodyTableData["size"];
        if (data && data.size) size = data.size;
        else size = { x: 100, y: 100 };
        const score = getScore(plan, task)!;
        let clef = score.clef || "treble";
        const accidental = score.doClef ? 0 : getAccidental({ _do: doPos });
        let position = (score.hideClefs ? 0 : clefWidth[score.doClef ? "doClef" : clef]) + 2 * size.y + (Math.abs(accidental) + 0.8) * 0.88 * size.y;
        const barlineWidths = getBarlinesWidth(bars[0].length > 0, barlines, bars.length - 1, size.y, size.x, "array") as number[];
        outer: for (let b = 0; b <= bar; b++) {
            for (let n = 0; n < bars[b].length; n++) {
                if (b === bar && note === n) {
                    break outer;
                }
                const { l, d } = bars[b][n];
                position += (4 / l) * (d ? 1.5 : 1) * size.x;
            }
            position += barlineWidths[b] || 0;
        }
        const lowDim = isLow ? 0.52 : 1;
        if (isLow) {
            position *= lowDim;
        }
        const screenWidth = 1280 * (isLow ? lowDim : 1);
        const scrollLeft = this.scroll!.scrollLeft;
        position -= scrollLeft;
        if (screenWidth - position < 120) {
            scrollTo(this.scroll!, scrollLeft + screenWidth * 0.7, 1000, t => null);
        }
    };

    checkReady = () => {
        const { solutions } = this.state;
        const bars = this.state.bars as IMelodyTableNote[][];
        let ready = true;
        solutions.forEach((bar, barIndex) => {
            bar.forEach((note, noteIndex) => {
                if (note && Object.keys(note).length === 0 && bars[barIndex][noteIndex].p !== null) {
                    ready = false;
                }
            });
        });
        if (ready) {
            this.setState({ submitable: true });
        } else {
            this.setState({ submitable: false });
        }
    };

    submit = () => {
        const { solutions, bars, incorrects } = this.state;
        let completed = true;
        incorrects.forEach(bar => {
            bar.length = 0;
        });
        (bars as IMelodyTableNote[][]).forEach((bar, barIndex) => {
            if (!bar) return;
            bar.forEach((note, noteIndex) => {
                if (note.p === null) return;
                if (note.p !== solutions[barIndex][noteIndex]?.p || note.a !== (solutions[barIndex][noteIndex]?.a || 0)) {
                    completed = false;
                    incorrects[barIndex].push(noteIndex);
                }
            });
        });

        if (completed) {
            if (this.props.completed) {
                this.props.completed("melodyTable");
            }
        } else {
            this.props.handleFailCount!();
        }

        this.setState({ incorrects, submited: true, completed });
    };

    blur = () => {
        this.play();
    };

    play = (checkPlay = false) => {
        const { scale, playing, checkPlaying, solutions } = this.state;
        const bars = this.state.bars as IMelodyTableNote[][];
        if (playing || checkPlaying) {
            window.removeEventListener("blur", this.blur);
            this.setState({ playing: false, checkPlaying: false, playingProps: {} });
            this.clock.stop();
            piano.stop();
            delete this.clock;
            window.cancelAnimationFrame(this.playScrollAnimation);
            return;
        }
        window.addEventListener("blur", this.blur);
        const notes = [];
        let t = 0;
        let late = 0.2;
        this.clock = new Clock(player.context, { toleranceEarly: 0.1 });
        this.clock.start();
        if (!checkPlay) {
            this.props.handlePlayCount!();
        }
        const { plan, task } = this.props;
        let tempo = getTempo(plan, task);
        let lastNote;
        for (let b = 0; b < bars.length; b++) {
            let bar = bars[b];
            for (let n = 0; n < bar.length; n++) {
                let note = bar[n];
                let noteLength = (4 / note.l) * (60 / tempo) * (note.d ? 1.5 : 1) * (note.t ? 0.67 : 1);
                let prolong = 0;
                if (note.tie) {
                    let nextNote = bar[n + 1];
                    if (!nextNote) {
                        nextNote = bars[b + 1][0];
                    }
                    prolong = (4 / nextNote.l) * (60 / tempo) * (nextNote.d ? 1.5 : 1) * (nextNote.t ? 0.67 : 1);
                }
                if (
                    (!checkPlay && note.p !== null && (!lastNote || !lastNote.tie)) ||
                    (checkPlay && solutions[b][n] && Object.keys(solutions[b][n]!).length !== 0 && (!lastNote || !lastNote.tie))
                ) {
                    notes.push({
                        time: t,
                        note: checkPlay
                            ? scale[
                                  scale.findIndex(
                                      tone => tone.tone === solutions[b][n]!.p && tone.a === solutions[b][n]!.a
                                  )
                              ].piano
                            : scale[scale.findIndex(tone => tone.tone === note.p && tone.a === note.a)].piano,
                        duration: noteLength + prolong,
                    });
                }
                let event = this.clock.callbackAtTime(() => {
                    this.setState({
                        playingProps: {
                            bar: b,
                            note: n,
                        },
                    });
                }, player.context.currentTime + t + late);
                event.tolerance({ late: 0.01 });
                lastNote = note;
                t += noteLength;
            }
        }
        this.scroll!.scrollLeft = 0;
        let scrollWidth = this.scroll!.getBoundingClientRect().width;
        let frameScale = 1280 / scrollWidth;
        let scrollToX =
            (this.wrap!.getBoundingClientRect().width - scrollWidth) * frameScale * (this.props.isLow ? 666 / 1280 : 1);
        scrollTo(this.scroll!, scrollToX, t * 1000, t => (this.playScrollAnimation = t));
        let event = this.clock.callbackAtTime(this.play, player.context.currentTime + t + late);
        event.tolerance({ late: 0.01 });

        piano.schedule(player.context.currentTime + late, notes);
        if (checkPlay) {
            this.setState({ checkPlaying: true });
        } else {
            this.setState({ playing: true });
        }
    };

    clickTone = async (e: TouchEvent | MouseEvent, fullTone: number, solutionNote: ISolutionNote | null, barIndex: number, noteIndex: number) => {
        if (!(await handleTouch(e))) return;
        const {
            task: {
                data: { hint },
            },
        } = this.props;
        const { scale, solutions } = this.state;
        const bars = this.state.bars as IMelodyTableNote[][];
        const hintable = isHintable({ bars, bar: bars[barIndex], noteIndex, hint, barIndex });
        let scaleIndex = scale.findIndex(tones => tones.tone === fullTone);
        if (hintable && bars[barIndex][noteIndex].p === fullTone && solutionNote?.p !== fullTone) {
            switch (bars[barIndex][noteIndex].a) {
                case 1:
                    await setStateAsync.call(this, { selectedModifier: "sharp" });
                    break;
                case -1:
                    await setStateAsync.call(this, { selectedModifier: "flat" });
                    break;
                default:
                    break;
            }
        }
        const { playing, checkPlaying, selectedModifier, completed } = this.state;
        if (!playing && !checkPlaying && (!solutionNote || solutionNote.p !== fullTone)) {
            let pianoTone = scale[scaleIndex].piano - scale[scaleIndex].a;

            if (selectedModifier === "sharp") pianoTone++;
            else if (selectedModifier === "flat") pianoTone--;
            const previousSameToneInBar = solutions[barIndex].slice(0, noteIndex).reverse().find(t => t !== null && t.p === fullTone);
            if (!!previousSameToneInBar && selectedModifier === null) {
                pianoTone += previousSameToneInBar.a || 0;
            }
            if (player?.context) {
                piano.play(pianoTone, player.context.currentTime, 0.6);
            }
        }
        if (completed) return;
        this.selectTone({
            barIndex,
            noteIndex,
            tone: fullTone,
        });
    };

    getDoPosition = () => {
        const { task, plan } = this.props;
        const score = getScore(plan, task)! as IScore;
        let doPosition = 0;
        const clef = score.clef || "treble";
        const clefType: "treble" | "bass" = (clef === "treble-octave" ? "treble" : clef);
        if (score.doClef) {
            const offset = (score.doClefOffset || [])[0] || 0;
            doPosition = getDoPosition(clefType, score, 0) + 4 - offset + clefCorrection[clefType];
        }
        return doPosition;
    }

    render() {
        const {
            bars,
            fullToneset,
            scale,
            width,
            solutions,
            incorrects,
            submitable,
            submited,
            selectedModifier,
            doPos,
            playing,
            completed,
            checkPlaying,
            barlines,
            hasSharp,
            hasFlat,
            playingProps,
        } = this.state;
        const { task, isLow, isDemo, plan, handleHomeworkNext, intl: { locale }, isEaster, isChristmas } = this.props;
        const { data } = task;
        if (!bars || !data)
            return (
                <div>
                    <div>
                        <Wrapper>
                            <NotEdited />
                        </Wrapper>
                    </div>
                </div>
            );
        const score = getScore(plan, task)!;
        const { position } = data;
        const accidental = score.doClef ? 0 : getAccidental({ _do: doPos });
        let size: IMelodyTableData["size"];
        if (data && data.size) size = data.size;
        else size = { x: 100, y: 100 };
        let clef = score.clef || "treble";
        const lowDim = isLow ? 0.52 : 1;
        const doPosition = this.getDoPosition();
        return (
            <div>
                {!!bars && (
                    <Wrapper isDemo={isDemo}>
                        {isLow && (
                            <>
                                <Asset1Wrapper>
                                    <img src={getBirdsPath("/melodyTable/asset-01.svg")} alt="decoration" />
                                </Asset1Wrapper>
                                <Asset2Wrapper>
                                    <img src={getBirdsPath("/melodyTable/asset-02.svg")} alt="decoration" />
                                </Asset2Wrapper>
                                <Asset3Wrapper>
                                    <img src={getBirdsPath("/melodyTable/asset-03.svg")} alt="decoration" />
                                </Asset3Wrapper>
                            </>
                        )}
                        <ScrollWrap isLow={isLow}>
                            <Scroll ref={s => (this.scroll = s)}>
                                <Wrap
                                    style={{
                                        width:
                                            (width * size.x +
                                                (score.hideClefs ? 0 : clefWidth[score.doClef ? "doClef" : clef]) +
                                                2 * size.y +
                                                ((score.doClef || score.hideClefs) ? 0 : ((Math.abs(accidental) + 0.8) * 0.88 * size.y)) +
                                                (getBarlinesWidth(
                                                    bars[0].length > 0,
                                                    barlines,
                                                    bars.length - 1,
                                                    size.y,
                                                    size.x
                                                ) as number)) *
                                            lowDim, //(bars.length - 1) * normalBarlineWidth(size.y)
                                    }}
                                    ref={w => (this.wrap = w)}
                                >
                                    <StaffLines
                                        style={{
                                            transform: `translateY(${position * lowDim || 0}px)`,
                                        }}
                                    >
                                        {[0, 1, 2, 3, 4].map(line => {
                                            return (
                                                <StaffLine
                                                    key={line}
                                                    isChristmas={isChristmas}
                                                    style={{
                                                        marginTop: -((size.y / 25) * lowDim * 1.75),
                                                        marginBottom: line < 4 ? size.y * lowDim : 0,
                                                        height: (size.y / 25) * lowDim * 2,
                                                    }}
                                                ></StaffLine>
                                            );
                                        })}
                                        <System>
                                            {!score.hideClefs && !score.doClef && (
                                                <>
                                                    <Clef style={{ top: size.y * lowDim * 3 }} isLow={isLow} isChristmas={isChristmas}>
                                                        {(clef === "treble" || clef === "treble-octave") && (
                                                            <ClefViolin
                                                                height={((840 * size.y) / 120) * lowDim}
                                                                marginTop={((-550 * size.y) / 120) * lowDim}
                                                            />
                                                        )}
                                                        {clef === "bass" && (
                                                            <ClefBass
                                                                height={((420 * size.y) / 120) * lowDim}
                                                                marginTop={((-372 * size.y) / 120) * lowDim}
                                                            />
                                                        )}
                                                        {clef === "treble-octave" && (
                                                            <OctaveMark
                                                                style={{
                                                                    top: (278 * size.y) / 120,
                                                                    fontSize: (100 * size.y) / 120,
                                                                    left: (96 * size.y) / 120,
                                                                }}
                                                            >
                                                                <i className="s-number_8" />
                                                            </OctaveMark>
                                                        )}
                                                    </Clef>
                                                </>
                                            )}
                                            {!score.hideClefs && score.doClef && (
                                                <>
                                                    <ClefLedgerHolder>
                                                        {[-6, -4, -2, 10, 12, 14].map(line => {
                                                            const clefType: "treble" | "bass" = (clef === "treble-octave" ? "treble" : clef);
                                                            const position = doPosition;
                                                            if ((position <= line && line < 0) || (position >= line && line > 0)) {
                                                                return (
                                                                    <ClefLedger
                                                                        key={line}
                                                                        style={{
                                                                            top: ((-clefTop[clefType] - 4 / 2 + clefCorrection[clefType] / 2) * size.y + (line - 4) * (size.y / 2)) * lowDim,
                                                                            left: 0,
                                                                            width: size.y * 1.92 * lowDim,
                                                                            height: size.y / 22 * 2 * lowDim,
                                                                            marginTop: -size.y / 22 * lowDim,
                                                                        }}
                                                                    />
                                                                )
                                                            }
                                                            return null;
                                                        })}
                                                    </ClefLedgerHolder>
                                                    <DoClef
                                                        style={{
                                                            top: doPosition * size.y / 2 * lowDim,
                                                            fontSize: size.y * 1.75 * lowDim,
                                                            marginTop: -size.y * 1.28 * lowDim,
                                                            marginRight: 18.4 * (size.y / 100) * lowDim,
                                                        }}
                                                    >
                                                        {getDo(locale)}
                                                    </DoClef>
                                                </>
                                            )}
                                            <Accidentals
                                                style={{
                                                    marginLeft: 20 * lowDim,
                                                    marginRight: 20 * lowDim,
                                                }}
                                            >
                                                {!score.hideClefs && accidental > 0 &&
                                                    [1, 2, 3, 4, 5, 6, 7].map(acc => {
                                                        if (acc > accidental) return null;
                                                        return (
                                                            <Accidental
                                                                key={acc}
                                                                style={{
                                                                    top:
                                                                        (((sharpPosition[clef][acc]! + 4) * size.y) /
                                                                            2) *
                                                                        lowDim,
                                                                }}
                                                            >
                                                                <span
                                                                    className="s-sharp"
                                                                    style={{
                                                                        fontSize: ((290 * size.y) / 106) * lowDim,
                                                                        transform: `translateY(${
                                                                            ((-160 * size.y) / 112) * lowDim
                                                                        }px)`,
                                                                    }}
                                                                />
                                                            </Accidental>
                                                        );
                                                    })}
                                                {!score.hideClefs && accidental < 0 &&
                                                    [1, 2, 3, 4, 5, 6, 7].map(acc => {
                                                        if (-acc < accidental) return null;
                                                        return (
                                                            <Accidental
                                                                key={acc}
                                                                style={{
                                                                    top:
                                                                        (((flatPosition[clef][acc]! + 4) * size.y) / 2) *
                                                                        lowDim,
                                                                }}
                                                            >
                                                                <span
                                                                    className="s-flat"
                                                                    style={{
                                                                        fontSize: ((290 * size.y) / 106) * lowDim,
                                                                        transform: `translateY(${
                                                                            ((-160 * size.y) / 120) * lowDim
                                                                        }px)`,
                                                                    }}
                                                                />
                                                            </Accidental>
                                                        );
                                                    })}
                                            </Accidentals>
                                            {bars.map((bar, barIndex) => {
                                                if (!bar.length) return null;
                                                return (
                                                    <MelodyTableBar
                                                        key={barIndex}
                                                        bar={bar}
                                                        fullToneset={fullToneset}
                                                        completed={completed}
                                                        size={size}
                                                        isLow={!!isLow}
                                                        lowDim={lowDim}
                                                        incorrects={incorrects}
                                                        solutions={solutions}
                                                        scale={scale}
                                                        clef={clef}
                                                        barIndex={barIndex}
                                                        submited={submited}
                                                        data={data}
                                                        accidental={accidental}
                                                        bars={bars}
                                                        barlines={barlines}
                                                        checkPlaying={checkPlaying}
                                                        playing={playing}
                                                        clickTone={this.clickTone}
                                                        playingProps={playingProps}
                                                        isChristmas={isChristmas}
                                                    />
                                                );
                                            })}
                                        </System>
                                    </StaffLines>
                                </Wrap>
                            </Scroll>
                        </ScrollWrap>
                        <PlayBtn
                            isEaster={isEaster}
                            isLow={!!isLow}
                            className={cn("button", "button--play")}
                            onClick={() => this.play()}
                            disabled={checkPlaying}
                        >
                            {playing ? <Icon i="stop" /> : <Icon i="play" />}
                            <Label>
                                <FormattedMessage {...messages.play} />
                            </Label>
                        </PlayBtn>
                        <CheckPlayBtn
                            isEaster={isEaster}
                            isLow={!!isLow}
                            className={cn("button", "button--check")}
                            onClick={() => this.play(true)}
                            disabled={playing || completed}
                        >
                            {checkPlaying ? <Icon i="stop" /> : <Icon i="play" />}
                            <Label>
                                <FormattedMessage {...messages.check} />
                            </Label>
                        </CheckPlayBtn>
                        {!completed && !submited && hasSharp && (
                            <StyledSharpButton
                                active={selectedModifier === "sharp"}
                                onClick={() => {
                                    if (selectedModifier === "sharp") {
                                        this.setState({ selectedModifier: null });
                                    } else {
                                        this.setState({ selectedModifier: "sharp" });
                                    }
                                }}
                            >
                                <Icon i="arrowup" />
                            </StyledSharpButton>
                        )}
                        {!completed && !submited && (hasFlat || hasSharp) && (
                            <StyledNaturalButton
                                active={selectedModifier === "natural"}
                                onClick={() => {
                                    if (selectedModifier === "natural") {
                                        this.setState({ selectedModifier: null });
                                    } else {
                                        this.setState({ selectedModifier: "natural" });
                                    }
                                }}
                            >
                                0
                            </StyledNaturalButton>
                        )}
                        {!completed && !submited && hasFlat && (
                            <StyledFlatButton
                                active={selectedModifier === "flat"}
                                onClick={() => {
                                    if (selectedModifier === "flat") {
                                        this.setState({ selectedModifier: null });
                                    } else {
                                        this.setState({ selectedModifier: "flat" });
                                    }
                                }}
                            >
                                <Icon i="arrowup" />
                            </StyledFlatButton>
                        )}
                        {submitable && !submited && !completed && (
                            <SubmitButton
                                isEaster={isEaster}
                                isLow={!!isLow}
                                style={{ top: isLow ? 30 : 6, bottom: "auto" }}
                                className={cn("button")}
                                onClick={() => {
                                    if (submitable) {
                                        this.submit();
                                    }
                                }}
                            >
                                <FormattedMessage {...messages.submit} />
                            </SubmitButton>
                        )}
                        {completed && (
                            <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="completed" handleHomeworkNext={handleHomeworkNext} />
                        )}
                        {submited && !completed && <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="incorrect" />}
                    </Wrapper>
                )}
            </div>
        );
    }
}

export default MelodyTable;
